import React, { Component } from "react";
import { connect } from "react-redux";
import { Switch, Route } from "react-router-dom";

//Components
import AdminPendingSection from './AdminPendingSection.js';

// State
import { addRoute } from "../../../store/actions/route";

class AdminPending extends Component {
	constructor(props) {
		super(props);
		this.props.addRoute(this.props.match);
	}

	// ===================================================================================
	//  RENDER
	// ===================================================================================
	render() {
		return (
			<Switch>
				<Route path={"/admin/registered"} exact component={AdminPendingSection} />
			</Switch>
		);
	}
}

export default connect(
	null,
	{ addRoute }
)(AdminPending);



// WEBPACK FOOTER //
// ./src/components/admin/pending/AdminPending.js